function Header() {
  return (
    <header className='app-header'>
      <img src='logo512.png' alt='React logo' />
      <h1>React TestZone</h1>
    </header>
  );
}

export default Header;
